import { useState, useRef, useEffect } from "react";
import { ChevronDown, Plus } from "lucide-react";
import { fetchMasterCities } from "../../services/locationServices";

const Header = ({ onClick, selectedCity, setSelectedCity }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    async function locationFetcher() {
      const geohash = localStorage.getItem("geohash") || "9v6m";
      const location = await fetchMasterCities({ geohash });
      setSelectedCity(location.data[0].city);
    }
    locationFetcher();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const selectCity = city => {
    setSelectedCity(city);
    setIsDropdownOpen(false);
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.leftSection}>
          {/* <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/liberty-icon-graphic-XOjyXvkwQ3Vhoyj7g4LHBfEd09lyVt.png"
            alt="City icon"
            style={styles.icon}
          />
          <div style={styles.dropdown} ref={dropdownRef}>
            <button style={styles.dropdownButton} onClick={toggleDropdown}>
              {selectedCity}
              <ChevronDown size={16} style={styles.chevron} />
            </button>
            {isDropdownOpen && (
              <div style={styles.dropdownContent}>
                {cities &&
                  cities.map((city) => (
                    <div
                      key={city}
                      style={styles.dropdownItem}
                      onClick={() => selectCity(city)}
                    >
                      {city}
                    </div>
                  ))}
              </div>
            )}
          </div> */}
        </div>
        <div style={styles.rightSection}>
          <button style={styles.createButton} onClick={onClick}>
            <Plus size={16} style={styles.buttonIcon} />
            Create Event
          </button>
        </div>
      </div>
    </header>
  );
};

// Inline styles
const styles = {
  header: {
    borderBottom: "1px solid #e5e7eb",
    padding: "2px 0"
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  icon: {
    width: "32px",
    height: "32px",
    objectFit: "contain"
  },
  dropdown: {
    position: "relative"
  },
  dropdownButton: {
    display: "flex",
    alignItems: "center",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    padding: "0"
  },
  chevron: {
    marginLeft: "4px"
  },
  dropdownContent: {
    position: "absolute",
    top: "100%",
    left: "0",
    backgroundColor: "white",
    minWidth: "160px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    zIndex: 1,
    borderRadius: "4px",
    marginTop: "4px"
  },
  dropdownItem: {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    "&:hover": {
      backgroundColor: "#f9f9f9"
    },
    "&:last-child": {
      borderBottom: "none"
    }
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  createButton: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "black",
    color: "white",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer"
  },
  filterButton: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    color: "black",
    border: "1px solid #e5e7eb",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer"
  },
  buttonIcon: {
    marginRight: "8px"
  }
};

export default Header;
